import { IRetailOrderDetails } from '@interfaces/myPurchasesInterfaces';

import { getLabelFallback } from '@utils/utils';

interface Props {
    orderDetail: IRetailOrderDetails;
}
const PaymentDetailsOrderRetailDetail = ({ orderDetail }: Props): JSX.Element => {
    const {
        orderTotal,
        orderStatus,
    } = orderDetail;
    return (
        <div className={`payment-container retail ${orderStatus != 'D' && 'large'}`}>
            <div className="payment-detail">
                <div className="shipping-payment-overview">
                    <div className="secondary-message large bold align-left">
                        {getLabelFallback(
                            'MYPURCHASES_RETAIL_ORDERS_ORDER_DETAIL_PAYMENT_DETAILS_OVERVIEW_TITLE'
                        )}
                    </div>
                    <div className="informations">
                        <span className="secondary-message bold medium small-mob align-left">
                            {getLabelFallback(
                                'MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_PAYMENT_DETAILS_PAYMENT_METHOD'
                            )}
                        </span>
                        <div className="secondary-message  medium small-mob align-left">
                            {orderDetail.paymentMethod?.toLowerCase().includes('amex')
                                ? <svg className="icon"><use xlinkHref="#cc-amex"></use></svg>
                                : orderDetail.paymentMethod?.toLowerCase().includes('americanexpress')
                                    ? <svg className="icon"><use xlinkHref="#cc-amex"></use></svg>
                                    : orderDetail.paymentMethod?.toLowerCase().includes('discovercard')
                                    ? <svg className="icon"><use xlinkHref="#cc-discover"></use></svg>
                                    : orderDetail.paymentMethod?.toLowerCase().includes('master card')
                                    ? <svg className="icon"><use xlinkHref="#cc-mastercard"></use></svg>
                                    : orderDetail.paymentMethod?.toLowerCase().includes('mastercard')
                                    ? <svg className="icon"><use xlinkHref="#cc-mastercard"></use></svg>
                                    : orderDetail.paymentMethod?.toLowerCase().includes('paypal')
                                    ? <svg className="icon"><use xlinkHref="#cc-paypal"></use></svg>
                                    : orderDetail.paymentMethod?.toLowerCase().includes('visa')
                                    ? <svg className="icon"><use xlinkHref="#cc-visa"></use></svg>
                                    : orderDetail.paymentMethod?.toLowerCase().includes('afterpay')
                                    ? <svg className="icon"><use xlinkHref="#cc-afterpay"></use></svg>
                                    : orderDetail.paymentMethod?.toLowerCase().includes('toafterpay')
                                    ? <svg className="icon"><use xlinkHref="#cc-afterpay"></use></svg>
                                    : orderDetail.paymentMethod?.toLowerCase().includes('toapplepay')
                                    ? <svg className="icon"><use xlinkHref="#cc-applepay"></use></svg>
                                    : ''
                                }
                                {!!orderDetail.paymentMethod && orderDetail.paymentMethod !== '' ? orderDetail.paymentMethod : 'OTHER'}
                        </div>
                    </div>
                </div>
                <div className="expense-report">
                    <div className="row">
                        <span className="secondary-message bold large align-left">
                            {getLabelFallback(
                                'IN_STORE_PURCHASES_MY_PURCHASES_TOTAL'
                            )}
                        </span>
                    </div>
                    <div className="row">
                        <span className="secondary-message bold large medium-mob align-left">
                            {getLabelFallback(
                                'MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_PAYMENT_ORDER_TOTAL'
                            )}
                        </span>
                        <div className="secondary-message large medium-mob align-right">${Number(orderTotal).toFixed(2)}</div> 
                    </div>
                </div>
            </div>
        </div>
    );
};
export default PaymentDetailsOrderRetailDetail;
